import { render, staticRenderFns } from "./unemploymentList.vue?vue&type=template&id=b59f16d6&scoped=true&"
import script from "./unemploymentList.vue?vue&type=script&lang=js&"
export * from "./unemploymentList.vue?vue&type=script&lang=js&"
import style0 from "./unemploymentList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./unemploymentList.vue?vue&type=style&index=1&id=b59f16d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59f16d6",
  null
  
)

export default component.exports